var React = require('react');

function Clock (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"cx":"75","cy":"75","r":"74","fill":"#FFF","fillRule":"nonzero","stroke":"#00C96F","strokeOpacity":".501","strokeWidth":"2","key":0}),React.createElement("g",{"stroke":"#121B26","strokeLinecap":"round","strokeWidth":"3.3","key":1},[React.createElement("path",{"d":"M62.881 99.84a28.541 28.541 0 0 0 15.444 4.51C94.162 104.35 107 91.513 107 75.676 107 59.838 94.162 47 78.325 47c-14.799 0-26.979 11.21-28.513 25.6-.064.603-.11 1.21-.136 1.822","key":0}),React.createElement("path",{"strokeLinejoin":"round","d":"M77.111 60.178v17.37l7.766 8.115M38 96.5h20M48 88.5h10M38 80.5h20","key":1})])]));
}

Clock.defaultProps = {"width":"150","height":"150","viewBox":"0 0 150 150"};

module.exports = Clock;

Clock.default = Clock;
